module.exports = __webpack_public_path__ + "static/media/menuCba.3d302e78.svg";